module.exports = __webpack_public_path__ + "33c0-1423.png";